
import { Modal, Divider, Row, Progress, Form, Drawer, Input, Button, Card, Tag, Select, Mentions } from 'antd';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { L } from '../../../../lib/abpUtility';
import AuthenticationStore from '../../../../stores/authenticationStore';
import Stores from '../../../../stores/storeIdentifier';
import Rules from '../../Validations/defaultValidations.validation';

export interface IContactFormProps {
    visible: boolean;
    primaryColor: string;
    secondaryColor: string;
    isMobile: boolean;
    authenticationStore: AuthenticationStore;
    location: any;
    onCancel: () => void;
    onLogin: (values: any) => void;
    formRef: any;
}

export interface IContactFormState {
    loading: boolean;
}

@inject(Stores.AuthenticationStore)
@observer
class ContactForm extends React.Component<IContactFormProps, IContactFormState> {

    state = {
        loading: false
    };

    handleFinish = async (values: any) => {

        const newValues = {
            ...values,
            interest: this.props.formRef.current?.getFieldValue('interest').toString()

        }

        this.props.onLogin(newValues); 
        this.props.formRef.current?.resetFields();
        this.props.onCancel();
    }

    render() {
        const { visible, isMobile, onCancel } = this.props;
        const { Option } = Select;
        const children = [<Option key={'Demo'} value={'Demo'}>{L('Demo')}</Option>,
        <Option key={'Partnership'} value={'Partnership'}>{L('Partnership')}</Option>, 
        <Option key={'Other'} value={'Other'}>{L('Other')}</Option>,];


        return (

            <div className="font-face-gm">

                <div>
                    <Modal
                        closable={this.props.isMobile === true ? true : false}
                        visible={isMobile === false ? (visible === true ? true : false) : false}
                        cancelText={L('Cancel')}
                        footer={null}
                        onCancel={onCancel}
                        title={null}>

                        <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '3em', marginBottom: '0px' }} >
                            {L('Contact Us')}
                        </Divider>
                        <Row style={{ marginBottom: '0px' }}>
                            <Progress
                                strokeColor={{
                                    from: this.props.secondaryColor,
                                    to: this.props.primaryColor,
                                }}
                                showInfo={false}
                                percent={100}
                                status="normal"
                                size={'small'}
                            />
                        </Row>

                        <Form ref={this.props.formRef} style={{ marginTop: '0px', marginBottom: '0px' }} name={'ContactForm'} onFinish={(e) => this.handleFinish(e)}>
                            <Card className="font-face-gm" bordered={false} style={{ padding: '0px', marginTop: '0px', marginBottom: '-10px' }}>

                                <div style={{ marginBottom: '35px' }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '1em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Name')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0' }}
                                            name={'name'} rules={Rules.requiredString}  >
                                            <Input disabled={this.state.loading} size='large' prefix={''} placeholder={L('Name')} />
                                        </Form.Item>


                                    </div>
                                </div>
                                <br />

                                <div style={{ marginBottom: '35px' }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '1em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Email')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0' }}
                                            name={'email'} rules={[
                                                {
                                                    type: 'email',
                                                    required: true,
                                                    message: L('Please enter a valid email')
                                                },
                                            ]}  >
                                            <Input disabled={this.state.loading} size='large' prefix={''} placeholder={L('Email')} />
                                        </Form.Item>


                                    </div>
                                </div>
                                <br />
                                <div style={{ marginBottom: '0px' }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '1em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Interest')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0' }}
                                            name={'interest'} rules={[
                                                {
                                                    required: true,
                                                    message: L('Please select an Interest')
                                                },]}  >
                                            <Select
                                                size='large'
                                                mode="multiple"
                                                style={{ width: '100%' }}
                                                placeholder={L('Please select')}
                                            //onChange={handleChange}
                                            >
                                                {children}
                                            </Select>
                                        </Form.Item>


                                    </div>
                                </div>

                                <br />
                                <div style={{ marginBottom: '60px', marginTop: '37px' }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '0.9em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Message')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0' }}
                                            name={'message'}    >
                                            <Mentions
                                                rows={2} style={{ width: '100%', textAlign: 'left' }}
                                                placeholder={L('...')}>
                                            </Mentions>
                                        </Form.Item>


                                    </div>
                                </div>
                                <br />
                                <div style={{ width: '100%', float: 'right', padding: '0', marginTop: '30px' }}>

                                    <Form.Item style={{ margin: '0', float: 'right' }}>
                                        <Button style={{ background: this.props.secondaryColor, borderColor: 'white' }} loading={this.state.loading} size='large' type="primary" shape='round' htmlType="submit" className="font-face-gm">
                                            {L('Submit')}
                                        </Button>
                                    </Form.Item>


                                </div>

                            </Card>

                        </Form>

                    </Modal>
                </div>


                <div>
                    <Drawer
                        closable={this.props.isMobile === true ? true : false}
                        onClose={onCancel}
                        visible={isMobile === true ? (visible === true ? true : false) : false}
                        footer={null}
                        width={this.props.isMobile === true ? (window.innerWidth * 0.9) : 420}
                        title={null} >
                        <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2.8em', marginBottom: '0px' }} >
                            {L('Contact Us')}
                        </Divider>
                        <Row style={{ marginBottom: '10px' }}>
                            <Progress
                                strokeColor={{
                                    from: this.props.secondaryColor,
                                    to: this.props.primaryColor,
                                }}
                                showInfo={false}
                                percent={100}
                                status="normal"
                                size={'small'}
                            />
                        </Row>

                        <Form ref={this.props.formRef} style={{ marginTop: '0px', marginBottom: '0px' }} name={'ContactForm'} onFinish={(e) => this.handleFinish(e)}>
                            <Card className="font-face-gm" bordered={false} style={{ padding: '0px', marginTop: '0px', marginBottom: '-10px' }}>

                                <div style={{ marginBottom: '30px' }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '1em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Name')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0' }}
                                            name={'name'} rules={Rules.requiredString}  >
                                            <Input disabled={this.state.loading} size='large' prefix={''} placeholder={L('Name')} />
                                        </Form.Item>


                                    </div>
                                </div>
                                <br />
                                <div style={{ marginBottom: '30px' }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '1em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Email')}</Tag>

                                    </div>


                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0' }}
                                            name={'email'} rules={[
                                                {
                                                    type: 'email',
                                                    required: true,
                                                    message: L('Please enter a valid email')
                                                },
                                            ]}  >
                                            <Input disabled={this.state.loading} size='large' prefix={''} placeholder={L('Email')} />
                                        </Form.Item>


                                    </div>
                                </div>
                                <br />
                                <div style={{ marginBottom: '30px' }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '0.9em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Interest')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0' }}
                                            name={'interest'} rules={[
                                                {
                                                    required: true,
                                                    message: L('Please select an Interest')
                                                },]} >
                                            <Select
                                                size='large'
                                                mode="multiple"
                                                style={{ width: '100%' }}
                                                placeholder="Please select"
                                            //onChange={handleChange}
                                            >
                                                {children}
                                            </Select>
                                        </Form.Item>


                                    </div>
                                </div> <br />
                                <div style={{ marginBottom: '0px' }}>
                                    <div style={{ width: '25%', float: 'left', padding: '0', margin: '0' }}>

                                        <Tag className="font-face-gm" style={{ float: 'left', paddingTop: '10px', fontSize: '0.9em', textAlign: 'center', width: '90%', height: '40px', resize: 'block' }}
                                            color={this.props.primaryColor}>{L('Message')}</Tag>

                                    </div>
                                    <div style={{ width: '75%', float: 'left', padding: '0', margin: '0' }}>
                                        <Form.Item style={{ margin: '0' }}
                                            name={'message'}    >
                                            <Mentions
                                                rows={2} style={{ width: '100%', textAlign: 'left' }}
                                                placeholder={L('...')}>
                                            </Mentions>
                                        </Form.Item>


                                    </div>
                                </div>
                                <div style={{ height: '15px' }}></div><br />
                                <div style={{ width: '100%', margin: 'auto', textAlign: 'center', padding: '0', marginTop: '50px' }}>

                                    <Form.Item >
                                        <Button loading={this.state.loading} size='large'
                                            type="primary" shape='round' htmlType="submit"
                                            className="font-face-gm" style={{ background: this.props.secondaryColor, borderColor: 'white' }}>
                                            {L('Submit')}
                                        </Button>
                                    </Form.Item>


                                </div>

                            </Card>

                        </Form>

                    </Drawer>
                </div>


            </div>
        );
    }

}

export default ContactForm;